import React from 'react'
import SEO from '@/components/atoms/SEO/SEO'

interface PageWrapperProps {
  title: string
  description: string
  url: string
  keywords?: string[]
  language?: string
  author?: string
  publishedTime?: string
  modifiedTime?: string
  children: React.ReactNode
}

const PageWrapper: React.FC<PageWrapperProps> = ({
  title,
  description,
  url,
  keywords = [],
  language = 'en',
  author = '© 2024 Ab4cus Tecnología',
  publishedTime,
  modifiedTime,
  children
}) => {
  return (
    <>
      <SEO
        title={title}
        description={description}
        url={url}
        keywords={keywords}
        language={language}
        author={author}
        publishedTime={publishedTime}
        modifiedTime={modifiedTime}
      />
      <main lang={language}>
        {children}
      </main>
    </>
  )
}

export default PageWrapper